import axiosClient from '../../configs/axios';

class OperatorMasterService {
    // Get list
    async getOperatorList(params) {
        try {
            const response = await axiosClient.get(
        `/operator/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add
    async addOperator(data) {
        try {
            const response = await axiosClient.post('/operator/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteOperator(data) {
        try {
            const response = await axiosClient.put(`/operator/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new OperatorMasterService();